import { Component, OnInit, OnDestroy } from '@angular/core';
import { UserModel } from 'src/app/core/models/user.model';
import { UserService } from 'src/app/core/services/user.service';
import { takeWhile } from 'rxjs/operators';
import { NbAccessChecker } from '@nebular/security';
import { NavigationEnd, Router } from '@angular/router';

@Component({
  selector: 'dum-main-private',
  templateUrl: './main-private.component.html',
  styleUrls: ['./main-private.component.scss']
})
export class MainPrivateComponent implements OnInit, OnDestroy {

  userLogged: UserModel;
  alive = true;
  height: string = (window.screen.height - 164).toString() + 'px';
  constructor(
    private userService: UserService,
    public accessChecker: NbAccessChecker
  ) {
    this.userService.findMe()
    .pipe(takeWhile(() => this.alive))
    .subscribe((user) => this.userLogged = user);
   }
  ngOnDestroy(): void {
    this.alive = false;
  }

  ngOnInit(): void {
  }

}
